
import extend from "extend";
import axios from "axios";
import qs from "qs";
import store from "store";
import Cookie from 'js-cookie'
import { Message } from "element-ui";
const netApi = axios.create({});
netApi.interceptors.response.use(
    res => res,
    error => {
        try {
            if (document.querySelector(".el-message--error")) {
                Message.closeAll();
            }
        } catch (e) {
            console.log(e);
        }
        if(error.response && error.response.status === 401){
            Message({
                type: 'error',
                message: Cookie.get('language') === 'en'  ? 'Authentication has expired, please log in again' : '身份认证已过期，请重新登录',
                onClose(){
                    if(store.state.isHideLogin){
                        const boxLoginUrl = store.getters.boxLoginUrl
                        sessionStorage.removeItem('store')
                        Cookie.remove('X-LENOVO-SESS-ID', { path: '/' })
                        Cookie.remove('language', { path: '/' })
                        window.location.href = boxLoginUrl
                    }else{
                        window.location.href = '/login'
                    }

                }
            })

        }else{
            return Promise.reject(error);
        }
    }
);

// 拦截器，处理断网情况
netApi.interceptors.request.use(
    config => {
        if (!navigator.onLine) {
            return Promise.reject({
                code: 600,
                message: "offline"
            });
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);
const VERSION = "/v2";
const URL = {
    getBoxUserInfo : "/gl/edas/user_info",
    getUserInfo: "/user/info/get",
    getAccountInfo: "/account/info/get",
    getCustomizeInfo: "/account/funs/get",
    getAccountConfig: "/config/getAccountConfig", //获取账户默认信息
    getSession: "/account/getsess", //获取Session
    getBoxType: "/gl/edas/box_type",
    // edas
    agentQuery: "/gl/edas/agent/query", //代理服务配置
    agentCreat: "/gl/edas/agent/create", //agent创建接口
    agentOperate: "/gl/edas/agent/operate", //agent操作接口
    syncConfig: "/gl/edas/config/sync", //同步配置操作接口
    syncMode: "/gl/edas/config/syncMode", //获取同步方式
    syncConfigList: "/gl/edas/config/syncs", //获取导入服务配置列表
    syncExecute: "/gl/edas/sync/execute", //立即同步接口
    syncStatus: "/gl/edas/config/syncStatus", //获取同步状态
    getEdasLog: "/gl/edas/log/statistic", //获取导入日志
    getEdasLogDetail: "/gl/edas/log/search", //获取edas日志详情
    exportEdasLog: "/gl/edas/log/export", //导出edas单条日志
    filterList: "/gl/edas/filter/listForPages", //过滤条件列表
    filterConfig: "/gl/edas/filter/rule", //添加过滤条件,删除过滤条件
    batchImportFilteringRule: "/gl/edas/filter/import/", //批量导入过滤条件
    authConfigList: "/gl/edas/auth/configs", //获取登录认证服务配置列表
    scanConfigList: "/gl/edas/qrcode/configs", //wxdingding获取登录认证服务配置列表
    ssoConfigList: "/gl/edas/sso/configs", //wxdingding单点登录配置列表
    authConfig: "/gl/edas/auth/config", //导入服务配置操作
    scanConfig: "/gl/edas/qrcode/config", //wxdingding导入服务配置操作
    ssoConfig: "/gl/edas/sso/config", //wxdingding导入服务配置操作
    getcaptcha: "/gl/edas/getcaptcha",
    getPublickey: "/gl/edas/get_publickey",
    edasLogin: "/gl/edas/login",
    bindingConfig: "/gl/edas/bind/role", // 第三方绑定
    bindingConfigList: "/gl/edas/bind/roles",
    bindingExecute: "/gl/edas/bind/execute",
    getBindLog: "/gl/edas/bind/log/statistic",
    getBindLogDetail: "/gl/edas/bind/log/search",
    //list列表
    pluginManager: "/gl/plugin/manager",
    listData: "/gl/plugin/managers",
    managerStart: "/gl/plugin/manager/start",
    managerStop: "/gl/plugin/manager/stop",
    managersStart: "/gl/plugin/managers/start",
    managersStop: "/gl/plugin/managers/stop",
    managersDel: "/gl/plugin/managers/del",
    //应用管理 集成管理
    getRegionList: "/gl/plugin/region",
    getRegionExist: "/gl/apimanage/regionExist",
    clientConfigData: "/gl/apimanage/plugins/config_data",
    apiManagerCreate: "/gl/apimanage/client",
    apiManagerInfo: "/gl/apimanage/client",
    getApiManagerList: "/gl/apimanage/client",
    modifyApiManager: "/gl/apimanage/client",
    deleteApiManager: "/gl/apimanage/client",
    getApiManagerRate: "/gl/apimanage/client",
    modifyApiManagerRate: "/gl/apimanage/client",
    getFunctionList: "/gl/apimanage/function",
    getPermissionList: "/gl/apimanage/client",
    getManageCategory: "/gl/apimanage/category",
    checkAppName: "/gl/apimanage/client",
    modifyManageCategory: "/gl/apimanage/client_access?_method=put",
    getLicenseInfo: '/gl/license/usage',
    checkIp: '/gl/apimanage/ip/check',
    // openapi菜单接口
    getApiMenu: "/gl/apimanage/category",
    getApiData: "/gl/apimanage/function",
    // ad 优化
    getBaseDN: "/gl/agent/plugin/ldap/search", // POST
    checkDN: "/gl/agent/plugin/ldap/verifydn",
    getFilterList: "/gl/edas/config/sync/ad_filter_rules",

};
export default {
    get(url, params, done, error, options) {
        const account_id = store.state.isHideLogin ?  store.getters.boxUserInfo.account_id :  store.getters.accountId
        const uid = store.state.isHideLogin ?  store.getters.boxUserInfo.uid : store.getters.uId
        let u,
        opt = null;
    const DEFAULT = {
        account_id,
        uid,
        _: Date.parse(new Date())
    };
    if (params === null) {
        u = URL[url];
        params = DEFAULT;
    } else {
        u = params.url ? URL[url] + params.url : URL[url];
        if (params.url) delete params.url;
        params = Object.assign({}, params, DEFAULT);
    }
    opt = extend(true, {}, options, { params });
    return netApi.get(VERSION + u, opt).then(done, error);
    },
    getData(url, params, done, error, options) {
        const account_id = store.state.isHideLogin ?  store.getters.boxUserInfo.account_id :  store.getters.accountId
        const uid = store.state.isHideLogin ?  store.getters.boxUserInfo.uid : store.getters.uId
        let u,
            opt = null;
        const DEFAULT = {
            account_id,
            uid,
            S: store.getters.S,
            _: Date.parse(new Date())
        };
        if (params === null) {
            u = URL[url];
            params = DEFAULT;
        } else {
            u = params.url ? URL[url] + params.url : URL[url];
            if (params.url) delete params.url;
            params = Object.assign({}, params, DEFAULT);
        }
        opt = extend(true, {}, options, { params });
        return netApi.get(VERSION + u, opt).then(done, error);
    },
    // 可以终止的get请求
    getDataAbort(url, params, options) {
        const account_id = store.state.isHideLogin ?  store.getters.boxUserInfo.account_id :  store.getters.accountId
        const uid = store.state.isHideLogin ?  store.getters.boxUserInfo.uid : store.getters.uId
        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();
        let u,
            opt = null;
        let DEFAULT = {
            account_id,
            uid,
            S: store.getters.S,
            _: Date.parse(new Date())
        };
        // 路径可能并不是以当前域名开头，如果不是，以传入的参数为准
        let vu = URL[url] ? VERSION + URL[url] : url;
        if (params == null) {
            u = vu;
            params = DEFAULT;
        } else {
            u = params.url ? VERSION + URL[url] + encodePath(params.url) : vu;

            if (params.url) delete params.url;
            params = Object.assign({}, params, DEFAULT);
        }
        opt = extend(true, {}, options, { params });
        opt.cancelToken = source.token;
        let action = axios.get(u, opt);
        return { source, action };
    },
    getDataWithOption(url, params, done, error, options) {
        const account_id = store.state.isHideLogin ?  store.getters.boxUserInfo.account_id :  store.getters.accountId
        const uid = store.state.isHideLogin ?  store.getters.boxUserInfo.uid : store.getters.uId
        let u,
            opt = null;
        const DEFAULT = {
            account_id,
            uid,
            S: store.getters.S,
            _: Date.parse(new Date())
        };
        if (params === null) {
            u = URL[url];
            params = DEFAULT;
        } else {
            u = params.url ? URL[url] + params.url : URL[url];
            if (params.url) delete params.url;
            params = Object.assign({}, params, DEFAULT);
        }
        if (options) {
            u += "/" + options;
        }
        opt = extend(true, {}, options, { params });
        return netApi.get(VERSION + u, opt).then(done, error);
    },
    getDataWithPath(url, path, params, done, error, options) {
        const account_id = store.state.isHideLogin ?  store.getters.boxUserInfo.account_id :  store.getters.accountId
        const uid = store.state.isHideLogin ?  store.getters.boxUserInfo.uid : store.getters.uId
        let getMapping = "";
        if (params && params.filename) {
            getMapping = VERSION + URL[url] + path + "/" + params.filename;
        } else {
            getMapping = VERSION + URL[url] + path;
        }
        getMapping += "?S=" + store.getters.S;
        delete params["path"];
        delete params["filename"];
        let opt = extend(true, {}, options, { params });
        return netApi.get(getMapping, opt).then(done, error);
    },
    getDataNoVersion(url, params, done, error, options) {
        const account_id = store.state.isHideLogin ?  store.getters.boxUserInfo.account_id :  store.getters.accountId
        const uid = store.state.isHideLogin ?  store.getters.boxUserInfo.uid : store.getters.uId
        let opt = extend(true, {}, options, { params });
        return netApi.get(URL[url] + "?S=" + store.getters.S, opt).then(done, error);
    },
    post(url, data, done, error, options) {
        const account_id = store.state.isHideLogin ?  store.getters.boxUserInfo.account_id :  store.getters.accountId
        const uid = store.state.isHideLogin ?  store.getters.boxUserInfo.uid : store.getters.uId
        const DEFAULT = {
            account_id,
            uid,
            S: store.getters.S,
            _: Date.parse(new Date())
        };
        let opt = extend(true, {}, options);
        opt = Object.assign({}, opt, DEFAULT);
        url =  VERSION + URL[url]
        return netApi({
            method: "post",
            url: url,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "edas-type": "marne",
            },
            params: opt,
            data: data
        }).then(done, error);
    },
    postDataById(url, urlParams, data, done, error, options) {
        const account_id = store.state.isHideLogin ?  store.getters.boxUserInfo.account_id :  store.getters.accountId
        const uid = store.state.isHideLogin ?  store.getters.boxUserInfo.uid : store.getters.uId
        const DEFAULT = {
            account_id,
            uid,
            S: store.getters.S,
            _: Date.parse(new Date())
        };
        let opt = extend(true, {}, options);
        opt = Object.assign({}, opt, DEFAULT);
        return netApi
            .post(VERSION + URL[url] + urlParams, data, {
                params: opt,
                headers: { "Content-Type": "application/json;charset=UTF-8","edas-type": "marne", }
            }).then(done, error);
    },
    postDataByIdAuth(url, urlParams, data, done, error, options) {
        const account_id = store.state.isHideLogin ?  store.getters.boxUserInfo.account_id :  store.getters.accountId
        const uid = store.state.isHideLogin ?  store.getters.boxUserInfo.uid : store.getters.uId
        const DEFAULT = {
            account_id,
            uid,
            S: store.getters.S,
            _: Date.parse(new Date())
        };
        let opt = extend(true, {}, options);
        opt = Object.assign({}, opt, DEFAULT);
        return netApi
            .post(VERSION + URL[url] + urlParams, data, { params: opt })
            .then(done, error);
    },
    postMg(url, data, done, error, options) {
        return netApi({
            method: "post",
            url: VERSION + URL[url] + "?S=" + store.getters.S,
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "edas-type": "marne",
            },
            data: data
        }).then(done, error);
    },
    postFormuts(url, data, done, error, options) {
        return netApi({
            method: "post",
            url:
                VERSION +
                URL[url] + `?S=${store.getters.S}`,
            headers: {
                "Content-Type": "multipart/form-data",
                "edas-type": "marne",
            },
            data: data
        }).then(done, error);
    },
    postData(url, data, done, error, options) {
        const account_id = store.state.isHideLogin ?  store.getters.boxUserInfo.account_id :  store.getters.accountId
        const uid = store.state.isHideLogin ?  store.getters.boxUserInfo.uid : store.getters.uId
        const DEFAULT = {
            account_id,
            uid,
            S: store.getters.S,
            _: Date.parse(new Date())
        };
        let opt = extend(true, {}, options);
        opt = Object.assign({}, opt, DEFAULT);
        return netApi
            .post(VERSION + URL[url], data, { params: opt })
            .then(done, error);
    },
    postDataWithoutQuery(url, data, done, error, options) {
        let opt = extend(true, {}, options);
        opt = Object.assign({}, opt);
        return netApi
            .post(VERSION + URL[url] + "?S=" + store.getters.S, data, { params: opt })
            .then(done, error);
    },
    putData(url, data, done, error, options) {
        const account_id = store.state.isHideLogin ?  store.getters.boxUserInfo.account_id :  store.getters.accountId
        const uid = store.state.isHideLogin ?  store.getters.boxUserInfo.uid : store.getters.uId
        const DEFAULT = {
            account_id,
            uid,
            S: store.getters.S,
            _: Date.parse(new Date())
        };
        let opt = extend(true, {}, options);
        opt = Object.assign({}, opt, DEFAULT);
        return axios.put(VERSION + URL[url], data);
    },
    putMgData(url, params, data, done, error, options) {
        return netApi({
            method: "put",
            url: VERSION + URL[url] + params + "&S=" + store.getters.S,
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "edas-type": "marne",
            },
            data: data
        }).then(done, error);
    },
    postDataWithId(url, data, done, error, options) {
        let opt = extend(true, {}, options),
            putURL = "";
        if (opt.type === "switcher") {
            putURL = VERSION + URL[url] + `/${opt.id}/` + opt.suffix;
        } else {
            putURL = VERSION + URL[url] + `/${opt.id}`;
        }
        putURL +=  + "?S=" + store.getters.S;
        return netApi.post(putURL, data, opt).then(done, error);
    },
    /**
     * @param url_tail 以post方式提交时映射地址后面所需的一系列get方式的参数
     */
    uploadDataWithUrlTail(url, url_tail, data, done, error, options) {
        url_tail += "&S=" + store.getters.S;
        let opt = extend(true, {}, options);
        return upload
            .post(VERSION + URL[url] + url_tail, data, opt)
            .then(done, error);
    },
    postDataWithUrlTail(url, url_tail, data, done, error, options) {
        url_tail += "&S=" + store.getters.S;
        let opt = extend(true, {}, options);
        return netApi
            .post(VERSION + URL[url] + url_tail, data, opt)
            .then(done, error);
    },

    /**
     * 用 DataFrom 格式 post 数据
     * @param url
     * @param data 对象格式 {key: value}
     * @param options 配置
     * @returns {*}
     */
    postDataByDataForm(url, data, options, params) {
        if (options) {
            if (options.useBrackets) {
                data = qs.stringify(data, { arrayFormat: "brackets" });
            } else if (options.useRepeat) {
                data = qs.stringify(data, { arrayFormat: "repeat" });
            } else {
                data = qs.stringify(data);
            }
        } else {
            data = qs.stringify(data);
        }
        let u =
            options && options.urlParam
                ? URL[url] + options.urlParam + "&S=" + store.getters.S
                : URL[url] + + "?S=" + store.getters.S;
        return netApi.post(VERSION + u, data, params);
    },
    /**
     * delete方式删除数据
     */
    deleteData(url, url_tail, data, done, error, options) {
        url_tail += "&S=" + store.getters.S;
        return netApi
            .delete(VERSION + URL[url] + url_tail, data)
            .then(done, error);
    },
    deleteMgData(url, url_tail, data, done, error, options) {
        url_tail += "&S=" + store.getters.S;
        return netApi
            .delete(VERSION + URL[url] + url_tail, data)
            .then(done, error);
    },
    deleteDataWithOption(url, params, done, error, options) {
        const account_id = store.state.isHideLogin ?  store.getters.boxUserInfo.account_id :  store.getters.accountId
        const uid = store.state.isHideLogin ?  store.getters.boxUserInfo.uid : store.getters.uId
        let u,
            opt = null;
        const DEFAULT = {
            account_id,
            uid,
            S: store.getters.S,
            _: Date.parse(new Date())
        };
        if (params === null) {
            u = URL[url];
            params = DEFAULT;
        } else {
            u = params.url ? URL[url] + params.url : URL[url];
            if (params.url) delete params.url;
            params = Object.assign({}, params, DEFAULT);
        }
        if (options) {
            u += "/" + options;
        }
        opt = extend(true, {}, options, { params });
        return netApi.delete(VERSION + u, opt).then(done, error);
    },
    baseURL(url) {
        return VERSION + URL[url] + `?S=${store.getters.S}`;
    }
};



// WEBPACK FOOTER //
// ./static/js/api/getdata.js